/**
 * Standard receptacle classes used for autocount classification.
 * These match the combined keys generated by the backend.
 */
export const STANDARD_RECEPTACLE_CLASSES: Record<string, string> = {
  'wall_mounted__duplex_receptacle': 'Wall Mounted Duplex Receptacle',
  'ceiling_mounted__duplex_receptacle': 'Ceiling Mounted Duplex Receptacle',
  'floor_mounted__duplex_receptacle': 'Floor Mounted Duplex Receptacle',
  'wall_mounted__gfci_receptacle': 'Wall Mounted GFCI Receptacle',
  'ceiling_mounted__gfci_receptacle': 'Ceiling Mounted GFCI Receptacle',
  'floor_mounted__gfci_receptacle': 'Floor Mounted GFCI Receptacle',
  'wall_mounted__dedicated_receptacle': 'Wall Mounted Dedicated Receptacle',
  'ceiling_mounted__dedicated_receptacle': 'Ceiling Mounted Dedicated Receptacle',
  'floor_mounted__dedicated_receptacle': 'Floor Mounted Dedicated Receptacle',
  'wall_mounted__halfswitch_specific_circuit_receptacle': 'Wall Mounted Halfswitch Specific Circuit Receptacle',
  'ceiling_mounted__halfswitch_specific_circuit_receptacle': 'Ceiling Mounted Halfswitch Specific Circuit Receptacle',
  'floor_mounted__halfswitch_specific_circuit_receptacle': 'Floor Mounted Halfswitch Specific Circuit Receptacle',
  'wall_mounted__quadruplex_receptacle': 'Wall Mounted Quadruplex Receptacle',
  'ceiling_mounted__quadruplex_receptacle': 'Ceiling Mounted Quadruplex Receptacle',
  'floor_mounted__quadruplex_receptacle': 'Floor Mounted Quadruplex Receptacle',
  'furniture_mounted__duplex_receptacle': 'Furniture Mounted Duplex Receptacle',
  'furniture_mounted__gfci_receptacle': 'Furniture Mounted GFCI Receptacle',
  'furniture_mounted__dedicated_receptacle': 'Furniture Mounted Dedicated Receptacle',
  'furniture_mounted__halfswitch_specific_circuit_receptacle': 'Furniture Mounted Halfswitch Specific Circuit Receptacle',
  'furniture_mounted__quadruplex_receptacle': 'Furniture Mounted Quadruplex Receptacle',
};

/**
 * Legacy standard class names that should be removed or migrated.
 */
export const LEGACY_STANDARD_RECEPTACLE_NAMES = [
  'Furniture Mounted Receptacle'
];
